import { root } from './hardware-cycles';

export const hardwareCycles = {
  ...root,
};
